export default __webpack_public_path__ + "static/ai-9bc75139107046743c0367226b1d2368.svg";